import type { Route } from '~/core/router'

import * as partnerProgramDetails from '~/routes/partner-program/details'

export const route: Route = {
  children: [
    {
      path: '/:partnerProductId',
      component: [partnerProgramDetails.PartnerProgramDetailsPage],
      init: partnerProgramDetails.model.init,
      left: partnerProgramDetails.model.left,
      meta: {
        title: 'Partners',
      },
    },
  ],
}
